import { Network } from "rujira.js";
import { wallets } from "rujira.ui";
import { persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";
export const useRujiraStore = createWithEqualityFn()(persist((set, get) => {
    Promise.all(wallets.loadProviders().map(wallets.getAccounts)).then((accounts) => set({ accounts: accounts.flat() }));
    const getAccount = (activeAccount) => {
        return get().accounts.find(({ account }) => {
            return (account.provider === activeAccount?.provider &&
                account.network === activeAccount?.network);
        });
    };
    return {
        accounts: [],
        selected: () => {
            return getAccount(get().account);
        },
        account: (() => {
            try {
                return wallets.loadSelected();
            }
            catch (error) {
                console.error(error);
            }
        })(),
        setAccount: (account) => {
            set({ account });
            if (account.network === Network.Thorchain) {
                set({ bridgeAccount: undefined });
            }
            else {
                set({ bridgeAccount: account });
            }
            wallets.saveSelected(account.provider, account.network);
        },
        removeAccount: () => {
            set({ account: undefined });
            set({ bridgeAccount: undefined });
            wallets.clearSelected();
        },
        providers: wallets.loadProviders(),
        addProvider: (provider) => {
            wallets.addProvider(provider);
        },
        removeProvider: (provider) => {
            wallets.removeProvider(provider);
        },
        clearProviders: () => {
            wallets.clearProviders();
        },
    };
}, {
    name: "RujiraStore",
    partialize: (state) => ({
        bridgeAccount: state.bridgeAccount,
    }),
}));
//# sourceMappingURL=store.js.map